import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    BubbleReactionsAddDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../../../types";
import {
    getSurfaceStyle
} from "../../../../../../helpers/theme/elevation";
import {
    getFocusRingStyle
} from "../../../../../../helpers/theme/state";
import {
    concentric
} from "../../../../../../helpers/theme/concentric";
import {
    getCornerStyle
} from "../../../../../../helpers/theme/corner";
import {
    getHitArea
} from "../../../../../../helpers/theme/control";

const stylesheet = StyleSheet.create({
    stripStart: {
        bottom: "100%",
        start: 0
    },
    stripEnd: {
        bottom: "100%",
        end: 0
    }
});

export const useStyles = ({
    controlHeights,
    isFocusVisible,
    shapeConfigs,
    touchTargets,
    pointerType,
    shadowAlpha,
    elevations,
    radiuses,
    borders,
    colors,
    spaces,
    align
}: BubbleReactionsAddDynamicStyleType) => {
    const chipHeight = controlHeights.small - shapeConfigs.chipHeightOffset;

    const hitArea = getHitArea({
        visualSize: chipHeight,
        touchTargets,
        pointerType
    });

    const itemSize = Math.max(controlHeights.medium, hitArea.minHeight);

    const stripPadding = spaces.spacingXs;

    const itemRadius = concentric({
        outer: radiuses.chip,
        inset: stripPadding,
        role: radiuses.chip
    });

    const styles = {
        strip: {
            ...getSurfaceStyle({
                surface: "popover",
                shadowAlpha,
                elevations,
                borders,
                colors
            }),
            ...(align === "start" ? stylesheet.stripStart : stylesheet.stripEnd),
            marginBottom: spaces.spacingXs,
            ...getCornerStyle({
                radius: radiuses.chip,
                shapeConfigs
            }),
            gap: spaces.spacingXxs,
            padding: stripPadding
        } as Mutable<ViewStyle>,
        surface: {
            backgroundColor: colors.content.container.raised,
            borderColor: colors.content.border.subtle,
            ...getCornerStyle({
                radius: radiuses.chip,
                shapeConfigs
            }),
            borderWidth: borders.line,
            height: chipHeight,
            width: chipHeight
        } as Mutable<ViewStyle>,
        add: {
            minHeight: hitArea.minHeight,
            minWidth: hitArea.minHeight
        } as Mutable<ViewStyle>,
        item: {
            ...getCornerStyle({
                radius: itemRadius,
                shapeConfigs
            }),
            height: itemSize,
            width: itemSize
        } as Mutable<ViewStyle>,
        itemRadius
    };

    Object.assign(styles.surface, getFocusRingStyle({
        isFocusVisible,
        borders,
        colors
    }));

    return styles;
};
export default stylesheet;
